<template>
  <CommonLayout>
    <div class="access-instructions-card">
      <!-- 添加 router-view 来渲染子路由组件 -->
      <router-view></router-view>
    </div>
  </CommonLayout>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import MarkdownIt from 'markdown-it'
import hljs from 'highlight.js' 
import 'highlight.js/styles/atom-one-dark.css' 
import CommonLayout from '@/components/CommonLayout.vue'

const md = new MarkdownIt({
  highlight: function (str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return hljs.highlight(str, { language: lang }).value
      } catch (__) {}
    }
    return '' 
  }
})

const renderedMarkdown = ref('')
const accessKey = 'your-access-key'

const markdownContent = `
### 1. 概述
本接入说明文档旨在帮助开发者快速接入我们的服务。

### 2. 配置生成
#### 2.1 生成 accessKey
选择“控制台”，在通行密钥卡片中点击“生成”按钮，即可生成 accessKey 值。需注意：accessKey 一旦生成后无法再次生成，该值不会过期且无需在请求时配置。

#### 2.2 设置 Object 密钥
继续查看 Object 密钥卡片，点击“管理”按钮，在弹窗中填写 Object 密钥值。需注意：ObjectKey 修改后立即生效，请在使用前保证该值的准确性。

#### 2.3 生成临时密钥
选择“临时密钥”，点击“新增”按钮，即可生成一组临时密钥值。需注意：一个用户最多只能设置 2 组临时密钥，一般情况下建议用户使用其中一组，如怀疑临时密钥出现被他人使用的情况，可生成另外一组供业务替换后再把原数据删除，保证业务顺利切换。

#### 2.4 用户业务系统配置（以 yml 配置为例）
\`\`\`yaml
fos_client:
  objectKey: xxxx/yyyy
  server_url: URL
  tmp_token: TMP_TOKEN
  secret_key: SEC_KEY
\`\`\`

### 3. 接入步骤
#### 3.1 SDK 方式（当前仅支持 Java）
##### 3.1.1 引入依赖
##### 下载 jar 包 - fos - client - 1.1.3 - SNAPSHOT.jar，通过 maven 方式引入：
\`\`\`xml
<dependency>
    <groupId>com.yl</groupId>
    <artifactId>fos-client</artifactId>
    <version>1.1.3-SNAPSHOT</version>
</dependency>
\`\`\`

##### 3.1.2 调用入口
##### 调用入口均为 IFileOperationService。

#### 3.2 HTTP 方式
##### 3.2.1 根据临时令牌获取通行密钥
##### /fos/client/access_key

##### 3.2.2 文件上传

##### 3.2.3 文件下载

##### 3.2.4 文件路径查询

##### 3.2.5 文件删除
`

onMounted(() => {
  const processedMarkdown = markdownContent.replace('your-access-key', accessKey)
  renderedMarkdown.value = md.render(processedMarkdown)
})
</script>

<style scoped>
/* 移除页面特定样式和代码块样式 */
</style>